{
  "version": 1,
  "asset_id": "784e7dae-d5c4-488f-8025-111d105cd798",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/784e7dae-d5c4-488f-8025-111d105cd798/sylwia-conference-it.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/784e7dae-d5c4-488f-8025-111d105cd798/sylwia-conference-it.jpg",
  "original_filename": "sylwia-conference-it.jpg",
  "size": 145789,
  "content_type": "image/jpeg",
  "created_at": "2026-08-22T08:50:53Z"
}
